import { IllegalArgumentError } from 'faro-common-model';
export function toStudyEntityModificationInfoType(type) {
    if (['primary', 'secondary'].includes(type))
        return type;
    throw new IllegalArgumentError(`Invalid study entity modification type [${type}]`);
}
//# sourceMappingURL=study-entity-modification-info-type.js.map